/**
 * Related bills table for InvoiceManager.
 * Extracted from InvoiceManager.
 */

import styles from './invoiceManagerStyles';

interface BillRecord {
  id: string;
  bill_number?: string;
  vendor_name?: string;
  total?: number;
  status?: string;
  zoho_bill_id?: string;
  [key: string]: unknown;
}

export interface InvoiceBillsTableProps {
  bills: BillRecord[];
  formatCurrency: (amount: number) => string;
  getStatusColor: (status: string) => string;
}

export default function InvoiceBillsTable({ bills, formatCurrency, getStatusColor }: InvoiceBillsTableProps) {
  if (bills.length === 0) return null;

  return (
    <div style={styles.card}>
      <h2 style={styles.cardTitle}>Related Bills ({bills.length})</h2>
      <div style={styles.tableWrapper}>
        <table className="w-full" style={{ borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={styles.th}>Bill Number</th>
              <th style={styles.th}>Vendor</th>
              <th className="text-right" style={styles.th}>Amount</th>
              <th className="text-center" style={styles.th}>Status</th>
              <th className="text-center" style={styles.th}>Synced</th>
            </tr>
          </thead>
          <tbody>
            {bills.map((bill) => (
              <tr key={bill.id} style={styles.tableRow}>
                <td style={styles.td}>{bill.bill_number}</td>
                <td style={styles.td}>{bill.vendor_name}</td>
                <td className="text-right" style={styles.td}>{formatCurrency(bill.total ?? 0)}</td>
                <td className="text-center" style={styles.td}>
                  <span style={{ ...styles.smallBadge, backgroundColor: getStatusColor(bill.status ?? '') }}>
                    {bill.status}
                  </span>
                </td>
                <td className="text-center" style={styles.td}>
                  {bill.zoho_bill_id ? 'Yes' : 'No'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
